var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightAlign(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    width: 54.6875,
    height: 50,
    rx: 4,
    fill: "#F5DAF7",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2299_19099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 12.167H16C15.6464 12.167 15.3073 12.3075 15.0572 12.5575C14.8072 12.8076 14.6667 13.1467 14.6667 13.5003C14.6667 13.8539 14.8072 14.1931 15.0572 14.4431C15.3073 14.6932 15.6464 14.8337 16 14.8337H40C40.3536 14.8337 40.6928 14.6932 40.9428 14.4431C41.1929 14.1931 41.3334 13.8539 41.3334 13.5003C41.3334 13.1467 41.1929 12.8076 40.9428 12.5575C40.6928 12.3075 40.3536 12.167 40 12.167Z",
    fill: "#99439D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 22.8337C40.3536 22.8337 40.6928 22.6932 40.9428 22.4431C41.1929 22.1931 41.3334 21.8539 41.3334 21.5003C41.3334 21.1467 41.1929 20.8076 40.9428 20.5575C40.6928 20.3075 40.3536 20.167 40 20.167H24C23.6464 20.167 23.3073 20.3075 23.0572 20.5575C22.8072 20.8076 22.6667 21.1467 22.6667 21.5003C22.6667 21.8539 22.8072 22.1931 23.0572 22.4431C23.3073 22.6932 23.6464 22.8337 24 22.8337H40Z",
    fill: "#99439D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 29.5003C14.6667 29.8539 14.8072 30.1931 15.0572 30.4431C15.3073 30.6932 15.6464 30.8337 16 30.8337H40C40.3536 30.8337 40.6928 30.6932 40.9428 30.4431C41.1929 30.1931 41.3334 29.8539 41.3334 29.5003C41.3334 29.1467 41.1929 28.8076 40.9428 28.5575C40.6928 28.3075 40.3536 28.167 40 28.167H16C15.6464 28.167 15.3073 28.3075 15.0572 28.5575C14.8072 28.8076 14.6667 29.1467 14.6667 29.5003Z",
    fill: "#99439D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 37.5003C41.3334 37.1467 41.1929 36.8076 40.9428 36.5575C40.6928 36.3075 40.3536 36.167 40 36.167H24C23.6464 36.167 23.3073 36.3075 23.0572 36.5575C22.8072 36.8076 22.6667 37.1467 22.6667 37.5003C22.6667 37.8539 22.8072 38.1931 23.0572 38.4431C23.3073 38.6932 23.6464 38.8337 24 38.8337H40C40.3536 38.8337 40.6928 38.6932 40.9428 38.4431C41.1929 38.1931 41.3334 37.8539 41.3334 37.5003Z",
    fill: "#99439D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2299_19099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(11.6875 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlign);
export default __webpack_public_path__ + "static/media/right-align.7dde094891ed39f1455a3f1f9491ee47.svg";
export { ForwardRef as ReactComponent };